<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import './assets/styles/mobileM.css';
@import './assets/styles/mobileS.css';
@font-face {
    font-family: 'american_typewriter';
    src: url(./assets/fonts/american_typewriter.ttf) format('truetype');
}
body{
  word-break: keep-all;
}
input[type=text] {
  border-radius: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue